import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { from, Observable } from 'rxjs';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { BrowserService } from 'src/app/core/services/browser.service';
import { EmployeeService } from 'src/app/core/services/employee.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { JobService } from 'src/app/core/services/job.service';
import { MeetingService } from 'src/app/core/services/meeting.service';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { UserRoleService } from 'src/app/core/services/user-role.service';
import { UserService } from 'src/app/core/services/user.service';

declare var _: any;
declare var $: any;

@Component({
    selector: 'app-invite-user-to-meeting',
    templateUrl: './invite-user-to-meeting.component.html',
    styleUrls: ['./invite-user-to-meeting.component.css']
})
export class InviteUserToMeetingComponent implements OnInit {
    @ViewChild('inviteUserForm') inviteUserForm: NgForm;
    @ViewChildren('userForm') userForms: QueryList<NgForm>;
    @Input() jobMatchObject: any;
    @Input() itemType: string;
    @Input() jobMatchId: string;
    @Input() scheduleId: string;
    @Output() saveCallback = new EventEmitter<any>();

    scheduleData: any;
    selectedUserObjectsArray: any[] = [];
    userSearchPlaceholder = 'Type first name or last name or email to search.';
    itemDisplayLabel = '';
    userTypeLabel = '';
    companyName = '';
    companyId: any;
    clientName = '';
    clientId: any;
    jobId: any;
    sharedReqUserFromCorpOrBuOrVendor = 'Corp';
    sharedReqCorporationName = '';
    sharedReqBUName = '';
    createdByCompanyId: any;
    addUserTabIndex = 0;
    buList: any[] = [];
    poc: any;

    viewMode = false;
    savingFlag = false;
    showFormFlag = false;
    loadingFlag = false;
    isCorporateFlag = false;
    userSearchFlag = true;
    showAddUserOptionFlag = true;
    canAddUserAtCompanyLevel = false;
    canAddUserAtClientOrBULevel = false;
    isUserVendor = false;
    isSharedRequisitionAccessedByVendor = false;
    showTagsInput = true;
    showUserDetailsFlag = false;
    tabsLoaded = true;

    constructor(
        private authService: AuthService,
        private modalService: AngularModalService,
        private browserService: BrowserService,
        private jobMatchService: JobMatchService,
        private jobService: JobService,
        private userService: UserService,
        private userRoleService: UserRoleService,
        private employeeService: EmployeeService,
        private meetingService: MeetingService,
        private alertsAndNotificationsService: AlertAndNotificationsService
    ) { }

    ngOnInit(): void {
        this.scheduleData = {
            meetingScheduleId: this.scheduleId,
            isCompany: true,
            jobMatchId: this.jobMatchId,
            company: '',
            feedbackType: 'SINGLE',
            users: []
        };
        const userDetails = this.authService.getUserDetails();
        this.companyId = userDetails.company.companyId;
        this.isCorporateFlag = (userDetails.company.companyType === 'Corporation');
        this.scheduleData.company = this.companyId;
        this.jobId = this.jobMatchObject.jobMatchJobId;
        this.companyName = userDetails.company.companyName;
        this.clientName = this.jobMatchObject.jobMatchClientName;
        this.clientId = this.jobMatchObject.jobMatchClientId;

        this._setItemLabels();
        this._setCorporateAndSharedRequisitionDefaults();
        this._setUserCreationAccess();
        this.getScheduledItems();
        setTimeout(() => {
            if (this.browserService.isGoogleChrome()) {
                $('[placeholder=\'' + this.userSearchPlaceholder + '\']').attr('autocomplete', 'nope');
            }
        }, 200);
    }

    _setItemLabels() {
        switch (this.itemType) {
            case 'recruiterScreening':
                this.itemDisplayLabel = 'Recruiter Screening';
                this.userTypeLabel = 'Recruiter Screener';
                break;
            case 'phoneScreen':
                this.itemDisplayLabel = 'Phone Screen';
                this.userTypeLabel = 'Phone Screener';
                break;
            case 'interview':
                this.itemDisplayLabel = 'Interview';
                this.userTypeLabel = 'Interviewer';
                break;
        }
    }

    _setCorporateAndSharedRequisitionDefaults() {
        if (this.isCorporateFlag) {
            this.scheduleData.isCompany = this.jobMatchObject.isCorporateLevelRequisition;
            this._setBuList();
        }
        if (this.jobMatchObject.isSharedRequisition && !this.isCorporateFlag) {
            this.sharedReqCorporationName = this.jobMatchObject.corporateCompanyName;
            this.sharedReqBUName = this.jobMatchObject.clientOrBUName;
            if (this.jobMatchObject.isCorporateLevelRequisition) {
                this.sharedReqUserFromCorpOrBuOrVendor = 'Corp';
                this.scheduleData.isCompany = true;
            } else if (this.jobMatchObject.isClientOrBuLevelRequisition) {
                this.sharedReqUserFromCorpOrBuOrVendor = 'Bu';
                this.scheduleData.isCompany = false;
            }
            // Users can be added only for a vendor, and Corp or BU is always selected by default.
            this.showAddUserOptionFlag = false;
        }
    }

    _setBuList() {
        this.buList = [];
        if (!this.scheduleData.isCompany) {
            this.buList.push({ id: this.jobMatchObject.jobMatchClientId, name: this.jobMatchObject.jobMatchClientName });
        }
    }

    _setUserCreationAccess() {
        if (this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin() || (this.userRoleService.isLoggedInUserCompanyAdmin() && !this.isCorporateFlag)) {
            this.canAddUserAtCompanyLevel = true;
            this.canAddUserAtClientOrBULevel = true;
        } else if (this.isCorporateFlag) {
            this.canAddUserAtCompanyLevel = !this.jobMatchObject.hasNoAccessToCreateUserUnderCorporateOnMeetingSchedule;
            this.canAddUserAtClientOrBULevel = !this.jobMatchObject.hasNoAccessToCreateUserUnderBUOnMeetingSchedule;
        } else {
            this._setUserCreationAccessFromRoleScope();
        }
    }

    _setUserCreationAccessFromRoleScope() {
        this.userService.getUsersOnlyClientsOrBus(this.companyId, (clientsOrBus) => {
            this.userService.getUserRoleEntityScope((scope) => {
                if (scope.allclientOrBU) {
                    this.canAddUserAtCompanyLevel = true;
                    this.canAddUserAtClientOrBULevel = true;
                } else if (clientsOrBus.length) {
                    this.canAddUserAtCompanyLevel = false;
                    this.canAddUserAtClientOrBULevel = _.findIndex(clientsOrBus, { companyId: this.clientId }) !== -1;
                } else {
                    this.canAddUserAtCompanyLevel = false;
                    this.canAddUserAtClientOrBULevel = false;
                }
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    getScheduledItems() {
        this.loadingFlag = true;
        const onSuccess = (data) => {
            const meeting = (data || []).find(item => item.meetingScheduleId === this.scheduleId);
            this.createdByCompanyId = meeting ? meeting.company : null;
            this.meetingChanged();
        };
        const onError = (error) => {
            this.loadingFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        };
        if (this.itemType === 'recruiterScreening') {
            this.jobMatchService.getRecruiterScreeners(this.jobMatchId, this.companyId, null, false, onSuccess, onError);
        } else if (this.itemType === 'phoneScreen') {
            this.jobMatchService.getPhoneScreeners(this.jobMatchId, this.companyId, null, false, onSuccess, onError);
        } else {
            this.jobMatchService.getInterviewers(this.jobMatchId, this.companyId, null, false, onSuccess, onError);
        }
    }

    meetingChanged() {
        this.showFormFlag = false;
        this.loadingFlag = true;
        this.showUserDetailsFlag = false;
        this.userSearchFlag = true;
        if (this.jobMatchObject.isSharedRequisition && !this.isCorporateFlag) {
            this.isSharedRequisitionAccessedByVendor = true;
        }
        this.viewMode = this.createdByCompanyId !== null && this.createdByCompanyId !== undefined
            && this.createdByCompanyId !== this.companyId && !this.isCorporateFlag;
        this.jobMatchService.getMeetingDetails(this.scheduleId, (data) => {
            this.scheduleData.users = [];
            this.selectedUserObjectsArray = [];
            this.addUserTabIndex = 0;
            if (!this.viewMode) {
                if (this.isSharedRequisitionAccessedByVendor) {
                    this.showUserDetailsFlag = true;
                    this.userSearchFlag = false;
                }
            } else {
                this.isUserVendor = true;
                this.showUserDetailsFlag = true;
                this.userSearchFlag = false;
                this._getPocOnJob();
                this.buList.push({ id: this.jobMatchObject.jobMatchClientId, name: this.jobMatchObject.jobMatchClientName });
            }
            this.scheduleData.feedbackType = data.feedbackType;
            this.scheduleData.company = this.companyId;
            this.scheduleData.isCompany = data.isCompany;
            this.showFormFlag = true;
            this.loadingFlag = false;
        }, (error) => {
            this.loadingFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    _getPocOnJob(successCallback?: any) {
        this.jobService.getPocOnJob(this.jobMatchObject.jobMatchJobId, (data) => {
            this._massagePocData(data);
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error, 'danger');
        });
    }

    _massagePocData(pocDetails) {
        if (!_.isNull(pocDetails.id)) {
            this.poc = this._getUserObject();
            this.poc.bu = pocDetails.buId;
            this.poc.emailAddress = pocDetails.email;
            this.poc.firstName = pocDetails.firstName;
            this.poc.lastName = pocDetails.lastName;
            this.poc.phoneNumber = pocDetails.mobilephone;
            this.poc.title = pocDetails.title;
            this.poc.userId = pocDetails.id;
            this.poc.isPoc = true;
            this.scheduleData.users.push(this.poc);
            this.selectedUserObjectsArray.push(this._getAutoCompleteUserObject(this.poc));
        }
    }

    invite() {
        setTimeout(() => {
            if (!this.scheduleData.users.length) {
                if (!this.inviteUserForm.invalid) {
                    this.alertsAndNotificationsService.showAlertWithCallBack('No Users Selected', 'Please select at least one user to to invited ' + this.itemDisplayLabel + '.', 'warning', () => {
                        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    });
                }
                return;
            }
            let uIErrorExists = false;
            this.userForms.forEach((userForm) => {
                userForm.onSubmit(undefined as any);
                if (userForm.invalid) {
                    uIErrorExists = true;
                }
            });
            if (!uIErrorExists && !this.inviteUserForm.invalid) {
                this._sendInvite();
            }
        }, 200);
    }

    _sendInvite() {
        this.savingFlag = true;
        const inviteUsersData: any = {
            meetingScheduleId: this.scheduleData.meetingScheduleId,
            companyId: this.scheduleData.company,
            users: [...this.scheduleData.users],
            meetingInviteType: this.userSearchFlag ? 'EXISTING_USER_INVITE' : 'CREATE_EMPLOYEE_INVITE'
        };
        this.meetingService.inviteParticipant(inviteUsersData, true, () => {
            this.savingFlag = false;
            this.alertsAndNotificationsService.showAlertWithCallBack('Join Invite Sent', 'Join meeting invite sent successfully', 'success', () => {
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            });
            this.saveCallback.emit();
        }, (error) => {
            this.savingFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    _getAutoCompleteUserObject(val) {
        const tagUser: any = {};
        tagUser.displayString = val.firstName;
        tagUser.displayString += _.isNull(val.lastName) ? '' : (' ' + val.lastName);
        tagUser.displayString += ' - ' + val.emailAddress;
        tagUser.id = val.userId;
        tagUser.firstName = val.firstName;
        tagUser.lastName = val.lastName;
        tagUser.email = val.emailAddress;
        tagUser.title = val.title;
        tagUser.mobilephone = val.phoneNumber;
        tagUser.isIndividual = val.isIndividual;
        tagUser.isPoc = val.isPoc;
        if (this.isCorporateFlag || this.jobMatchObject.isSharedRequisition) {
            tagUser.buId = val.buId;
            tagUser.buName = val.buName;
        } else {
            tagUser.departmentName = val.department;
        }
        return tagUser;
    }

    toggleViewUserDetails() {
        this.showUserDetailsFlag = !this.showUserDetailsFlag;
        if (this.showUserDetailsFlag) {
            this.addUserTabIndex = 0;
        }
    }

    public getUsers = (searchTerm: string): Observable<any[]> => {
        const searchObject: any = {
            companyOrClientBuId: this.scheduleData.isCompany ? this.scheduleData.company : this.clientId,
            email: searchTerm,
            firstName: searchTerm,
            lastName: searchTerm,
            requisitionId: this.jobId,
            loggedInCompanyId: this.companyId
        };
        if (this.isSharedRequisitionAccessedByVendor) {
            if (this.sharedReqUserFromCorpOrBuOrVendor === 'Corp') {
                searchObject.companyOrClientBuId = this.jobMatchObject.corporateCompanyId;
            } else if (this.sharedReqUserFromCorpOrBuOrVendor === 'Bu') {
                searchObject.companyOrClientBuId = this.jobMatchObject.clientOrBUId;
            } else if (this.sharedReqUserFromCorpOrBuOrVendor === 'Vendor') {
                searchObject.companyOrClientBuId = this.companyId;
            }
        }
        return from(
            this.userService.getFilteredUsersPromiseForTypeAhead(searchObject).then((data: any) => {
                _.forEach(data, (val) => {
                    val.displayString = val.firstName;
                    val.displayString += _.isNull(val.lastName) ? '' : (' ' + val.lastName);
                    val.displayString += ' - ' + val.email;
                    val.buName = val.buName ? val.buName : 'Corporate';
                });
                return data;
            })
        );
    }

    public getDepartments = (searchTerm: string): Observable<any[]> => {
        const searchObject = {
            searchText: searchTerm,
            companyId: this.companyId
        };
        return from(this.employeeService.getDepartmentsPromiseForTypeAhead(searchObject).then((data: any) => data));
    }

    _resetScheduleData() {
        _.remove(this.scheduleData.users, (user: any) => user.isPoc === undefined || user.isPoc === false);
        _.remove(this.selectedUserObjectsArray, (userTag: any) => userTag.isPoc === undefined || userTag.isPoc === false);
    }

    addUser() {
        this.scheduleData.users.push(this._getUserObject());
        setTimeout(() => {
            this.addUserTabIndex = this.scheduleData.users.length - 1;
        }, 200);
    }

    removeUser(index: number) {
        this.tabsLoaded = false;
        this.scheduleData.users.splice(index, 1);
        setTimeout(() => {
            this.addUserTabIndex = 0;
            this.tabsLoaded = true;
        }, 1000);
    }

    getUserForm(index: number): NgForm | null {
        return this.userForms ? this.userForms.toArray()[index] : null;
    }

    _getUserObject() {
        const user: any = {};
        user.userId = null;
        user.temporaryUserId = Math.floor((Math.random() * 100) + 1).toString();
        user.firstName = '';
        user.lastName = '';
        user.emailAddress = '';
        user.title = '';
        user.phoneNumber = '';
        user.department = null;
        user.buId = '';
        user.buName = '';
        user.isIndividual = false;
        user.selectedDepartmentObjectsArray = [];
        if (this.isCorporateFlag && !this.scheduleData.isCompany) {
            user.buId = this.jobMatchObject.jobMatchClientId;
        }
        return user;
    }

    userTypeChanged() {
        if (!this.isCorporateFlag) {
            this._resetScheduleData();
        }
        if (!this.userSearchFlag && !this.scheduleData.users.some(user => user.userId == null)) {
            this.addUser();
        }
        if (this.inviteUserForm) {
            (this.inviteUserForm as any)._submitted = false;
        }
    }

    companyClientUserTypeChanged() {
        const usersCount = this.scheduleData.users.length;
        if (usersCount === 0 || (usersCount === 1 && this.scheduleData.users[0].isPoc) || this.isCorporateFlag) {
            this._switchCompanyClient();
        } else {
            this.alertsAndNotificationsService.showConfirm('Confirm', 'The chosen user(s) will be removed. Are you sure you want to continue?', 'warning', true, () => {
                this._switchCompanyClient();
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }, () => {
                this.scheduleData.isCompany = !this.scheduleData.isCompany;
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            });
        }
    }

    _switchCompanyClient() {
        this.showTagsInput = false;
        if (!this.isCorporateFlag) {
            this._resetScheduleData();
        }
        if (!this.isCorporateFlag && this.scheduleData.isCompany && !this.jobMatchObject.isSharedRequisition) {
            this.scheduleData.users = [];
            this.selectedUserObjectsArray = [];
        }
        // A staffing company can only pick the client's point of contact, never add users for a client.
        if (!this.isCorporateFlag && !this.scheduleData.isCompany) {
            this.scheduleData.users = [];
            this.selectedUserObjectsArray = [];
            this._getPocOnJob();
            this.showAddUserOptionFlag = false;
            if (!this.userSearchFlag) {
                this.userSearchFlag = true;
                this.userTypeChanged();
            }
        } else {
            this.showAddUserOptionFlag = true;
        }
        if (this.scheduleData.isCompany && !this.canAddUserAtCompanyLevel) {
            this.userSearchFlag = true;
            this.userTypeChanged();
        } else if (!this.scheduleData.isCompany && !this.canAddUserAtClientOrBULevel) {
            this.userSearchFlag = true;
            this.userTypeChanged();
        }
        if (this.isCorporateFlag) {
            this._setBuList();
        }
        setTimeout(() => {
            this.showTagsInput = true;
        }, 1000);
    }

    corpBuVendorUserTypeChanged(userType: string) {
        const usersCount = this.scheduleData.users.length;
        if (usersCount === 0 || (usersCount === 1 && this.scheduleData.users[0].isPoc)) {
            this._switchCorpBu();
        } else {
            this.alertsAndNotificationsService.showConfirm('Confirm', 'The chosen user(s) will be removed. Are you sure you want to cancel?', 'warning', true, () => {
                this._switchCorpBu();
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }, () => {
                this.sharedReqUserFromCorpOrBuOrVendor = userType === 'Corporation' ? 'Bu' : 'Corp';
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            });
        }
    }

    _switchCorpBu() {
        this._resetScheduleData();
        if (this.sharedReqUserFromCorpOrBuOrVendor === 'Corp') {
            this.scheduleData.isCompany = true;
            this.scheduleData.company = this.jobMatchObject.corporateCompanyId;
            this._showCorpOrBuUsersOnly();
        } else if (this.sharedReqUserFromCorpOrBuOrVendor === 'Bu') {
            this.scheduleData.isCompany = false;
            this.scheduleData.company = this.jobMatchObject.clientOrBUId;
            this._showCorpOrBuUsersOnly();
        } else if (this.sharedReqUserFromCorpOrBuOrVendor === 'Vendor') {
            this.scheduleData.isCompany = true;
            this.scheduleData.company = this.companyId;
            this.showAddUserOptionFlag = true;
            if (!this.canAddUserAtCompanyLevel) {
                this.userSearchFlag = true;
                this.userTypeChanged();
            }
        }
    }

    _showCorpOrBuUsersOnly() {
        this.showAddUserOptionFlag = false;
        this.userSearchFlag = true;
        this.userTypeChanged();
        if (this.isUserVendor) {
            this.scheduleData.users.push(this.poc);
            this.showUserDetailsFlag = true;
            setTimeout(() => {
                this.addUserTabIndex = 0;
            }, 100);
        }
    }

    userTypeAheadUserAdded(tag) {
        this.addUser();
        const user = this.scheduleData.users[this.scheduleData.users.length - 1];
        user.userId = tag.id;
        user.firstName = tag.firstName;
        user.lastName = tag.lastName;
        user.emailAddress = tag.email;
        user.title = tag.title;
        user.phoneNumber = _.isNull(tag.mobilephone) ? '-' : tag.mobilephone;
        if (!_.isNull(tag.role) && !_.isUndefined(tag.role) && tag.role.length > 0) {
            user.role = tag.role[this.scheduleData.users.length - 1].description;
        }
        if (this.isCorporateFlag || this.jobMatchObject.isSharedRequisition) {
            user.buId = tag.buId;
            user.buName = tag.buName;
        } else {
            user.department = tag.departmentName;
            if (!_.isNull(tag.departmentName) && !_.isUndefined(tag.departmentName)) {
                const department = { id: tag.departmentId, name: tag.departmentName };
                user.selectedDepartmentObjectsArray = [department];
                user.department = department;
            }
        }
        user.isIndividual = this.scheduleData.feedbackType !== 'SINGLE';
    }

    userTypeAheadUserRemoved(tag) {
        if (tag.isPoc) {
            this.selectedUserObjectsArray.unshift(tag);
            this.alertsAndNotificationsService.showAlertWithCallBack('Warning!', 'Point of Contact cannot be removed.', 'warning', () => {
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            });
        } else {
            const removedIndex = _.findIndex(this.scheduleData.users, { userId: tag.id });
            this.scheduleData.users.splice(removedIndex, 1);
        }
    }

    departmentTypeAheadDepartmentAdded(tag, user) {
        user.department = { name: tag.name };
        if (!_.isNull(tag.id) && !_.isUndefined(tag.id)) {
            user.department.id = tag.id;
        }
    }

    departmentTypeAheadDepartmentRemoved(tag, user) {
        user.department = null;
    }

    resetMeeting() {
        this.meetingChanged();
    }
}
